/**
 *
 * contains one picture
 *
 * series of [ grid ( contains mesh & texture) , mask ]
 *
 */
export default class model {

    constructor() {

        this._model = []

        this.picture = false

    }



    setPicture(picture) {

        this.picture = picture

    }



    getPicture() {

        return this.picture

    }



    /**
     * add model
     *
     * @param mask
     * @param grid
     */
    add(mask, grid) {

        this._model.push({

            //image:  image,  // @todo remove
            grid: grid,
            mask: mask

        })
        //console.log(this._model)

    }



    /**
     * remove model
     *
     * @param index
     * @returns {boolean}
     */
    remove(index = this._model.length - 1) {

        if (index <= this._model.length) {

            this._model.splice(index, 1)

            return index

        } else {

            return false

        }

    }



    getSize() {

        return this._model.length

    }



    get(index) {

        if (index < this.getSize())

            return this._model[index]

        return false

    }



    getImage(index) {

        if (index <= this.getSize())

            return this._model[index].image

        return false

    }



    getGrid(index) {

        if (index <= this.getSize())

            return this._model[index].grid

        return false

    }


    //try for history to remove
    /*setGrid( index , grid ) {

        if ( index <= this.getSize() ) {

            this._model[index].grid = grid

            return true

        }

        return false

    }*/



    getMask(index) {

        if (index <= this.getSize())

            return this._model[index].mask

        return false

    }


    /**
     * apply texture on all grids
     * @param texture
     */
    setTexture(texture) {

        this._model.forEach((m) => {

            m.grid.setTexture(texture)

        })

    }


    /**
     * apply material color on all grids
     * @param texture
     */
    setColor(color) {

        this._model.forEach((m) => {

            m.grid.material.color.set(color)

        })

    }


    /**
     * apply rotation angle on all grids
     * @param texture
     */
    setAngle(angle) {

        this._model.forEach((m) => {
            //console.log(m.grid)
            m.grid.material.map.rotation = angle
            m.grid.mesh.material.map.rotation = angle
            m.grid.mesh.rotation = angle

        })

    }


    /**
     * apply repeat texture
     * @param repeat
     */
    setRepeat(repeat) {

        this._model.forEach((m) => {

            m.grid.getTexture().repeat.set(repeat, repeat)

        })

    }


    /**
     * apply repeat texture
     * @param repeat
     */
    setTranslateTexture(x, y) {

        this._model.forEach((m) => {

            m.grid.getTexture().offset.set(x, y)

        })

    }




}